import { useState } from "react";
import { supabase } from "../supabase/supabaseClient";

export default function SignupMethod({
  userType,
  onEmailSignupSuccess,
  onSocialSignup,
}: {
  userType: string;
  onEmailSignupSuccess: () => void;
  onSocialSignup: () => void;
}) {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  // 이메일 회원가입
  async function handleEmailSignup(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    if (!email || !pw || !pw2) {
      setError("모든 정보를 입력해 주세요.");
      return;
    }
    if (pw !== pw2) {
      setError("비밀번호가 일치하지 않습니다.");
      return;
    }
    const { error } = await supabase.auth.signUp({
      email,
      password: pw,
      options: { data: { userType, level: "pending" }, 
      emailRedirectTo: window.location.origin + "/additional-info" }
    });
    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
      setTimeout(onEmailSignupSuccess, 1000);
    }
  }

  // 소셜 회원가입
  async function handleGoogleSignup() {
    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: window.location.origin + "/additional-info"
      }
    });
    onSocialSignup();
  }
  async function handleKakaoSignup() {
    await supabase.auth.signInWithOAuth({
      provider: "kakao",
      options: {
        redirectTo: window.location.origin + "/additional-info"
      }
    });
    onSocialSignup();
  }

  return (
    <div className="max-w-md mx-auto mt-20 p-8 shadow rounded bg-white">
      <h2 className="text-2xl font-bold mb-6 text-center">회원가입 방식 선택</h2>
      <div className="mb-8">
        <form onSubmit={handleEmailSignup}>
          <input
            type="email"
            className="border p-2 mb-2 w-full"
            placeholder="이메일"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <input
            type="password"
            className="border p-2 mb-2 w-full"
            placeholder="비밀번호"
            value={pw}
            onChange={e => setPw(e.target.value)}
          />
          <input
            type="password"
            className="border p-2 mb-4 w-full"
            placeholder="비밀번호 확인"
            value={pw2}
            onChange={e => setPw2(e.target.value)}
          />
          {error && <div className="mb-2 text-red-500">{error}</div>}
          {success ? (
            <div className="mb-2 text-green-600 font-semibold">이메일 인증 메일이 전송되었습니다!</div>
          ) : (
            <button type="submit" className="w-full bg-black text-white py-2 rounded mb-3">이메일로 가입</button>
          )}
        </form>
      </div>
      <div className="flex flex-col gap-2">
        <button
          type="button"
          onClick={handleGoogleSignup}
          className="w-full flex items-center justify-center border py-2 rounded mb-2 bg-white hover:bg-gray-100"
        >
          <img src="/google-icon.svg" alt="" className="w-5 h-5 mr-2" />
          Google로 가입/로그인
        </button>
        
      </div>
    </div>
  );
}
